(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["achievement-showcase"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  const section = document.querySelector('[data-cs-achievements]');
  if (!section) return;

  const grid = section.querySelector('[data-achievements-grid]');
  if (!grid) return;

  function loadAchievements() {
    if (!window.CyberSells_achievements || !window.CyberSells_playerData) {
      setTimeout(loadAchievements, 100);
      return;
    }

    const playerData = window.CyberSells_playerData.loadPlayerData();
    const allAchievements = window.CyberSells_achievements.getAllAchievements();
    const unlockedIds = new Set(playerData.achievements);

    // Get featured achievements (first 6, mix of locked and unlocked)
    const unlocked = allAchievements.filter(a => unlockedIds.has(a.id)).slice(0, 3);
    const locked = allAchievements.filter(a => !unlockedIds.has(a.id)).slice(0, 3);
    const featured = [...unlocked, ...locked].slice(0, 6);

    if (featured.length === 0) {
      grid.innerHTML = '<p class="cs-achievement-showcase__empty">No achievements available</p>';
      return;
    }

    grid.innerHTML = featured.map(achievement => renderAchievementCard(achievement, unlockedIds.has(achievement.id))).join('');
  }

  function renderAchievementCard(achievement, isUnlocked) {
    return `
      <div class="cs-achievement-card ${isUnlocked ? '' : 'cs-achievement-card--locked'}">
        <span class="cs-achievement-card__status">${isUnlocked ? 'Unlocked' : 'Locked'}</span>
        <div class="cs-achievement-card__icon">${achievement.icon}</div>
        <h3 class="cs-achievement-card__title">${achievement.title}</h3>
        <p class="cs-achievement-card__description">${achievement.description}</p>
        <div class="cs-achievement-card__reward">+${achievement.xpReward} XP</div>
      </div>
    `;
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadAchievements);
  } else {
    loadAchievements();
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gamification-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  const hero = document.querySelector('[data-cs-hero]');
  if (!hero) return;

  const statsContainer = hero.querySelector('[data-live-stats]');
  if (!statsContainer) return;

  // Animate stats on load
  function animateStats() {
    // Get player data if available
    if (window.CyberSells_playerData) {
      const playerData = window.CyberSells_playerData.loadPlayerData();
      
      // Mock global stats (in production, fetch from backend)
      const stats = {
        players: Math.floor(Math.random() * 500) + 100, // Mock: 100-600 players
        achievements: playerData.achievements.length * 10, // Mock multiplier
        quests: Math.floor(Math.random() * 1000) + 500 // Mock: 500-1500
      };

      // Animate numbers
      animateNumber(statsContainer.querySelector('[data-stat="players"]'), stats.players);
      animateNumber(statsContainer.querySelector('[data-stat="achievements"]'), stats.achievements);
      animateNumber(statsContainer.querySelector('[data-stat="quests"]'), stats.quests);
    }
  }

  function animateNumber(element, target) {
    if (!element) return;
    
    const duration = 2000;
    const steps = 60;
    const increment = target / steps;
    let current = 0;

    const timer = setInterval(() => {
      current += increment;
      if (current >= target) {
        element.textContent = target.toLocaleString();
        clearInterval(timer);
      } else {
        element.textContent = Math.floor(current).toLocaleString();
      }
    }, duration / steps);
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', animateStats);
  } else {
    animateStats();
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account"]) return;
  try {
    
(function() {
  'use strict';

  function renderPlayerStats() {
    const container = document.querySelector('[data-player-stats]');
    if (!container) return;

    // Wait for player data module
    if (!window.CyberSells_playerData || !window.CyberSells_achievements || !window.CyberSells_stats) {
      setTimeout(renderPlayerStats, 100);
      return;
    }

    const playerData = window.CyberSells_playerData.loadPlayerData();
    const achievements = window.CyberSells_achievements.getUnlockedAchievements(playerData);
    const progress = window.CyberSells_achievements.getAchievementProgress(playerData);
    
    // Calculate XP progress
    const xpForNext = window.CyberSells_stats.getXpForLevel(playerData.level);
    const xpProgress = (playerData.xp / xpForNext) * 100;

    let html = `
      <div class="player-stats-header">
        <h2>?? Player Profile</h2>
      </div>

      <div class="player-level-display">
        <div class="level-badge">${playerData.level}</div>
        <div class="level-info">
          <h3>Level ${playerData.level}</h3>
          <div class="xp-bar-container">
            <div class="xp-bar-fill" style="width: ${xpProgress}%"></div>
            <div class="xp-text">${playerData.xp} / ${xpForNext} XP</div>
          </div>
        </div>
      </div>

      <div class="player-stats-grid">
        <div class="stat-box">
          <span class="stat-label">STR</span>
          <span class="stat-value">${playerData.stats.str}</span>
        </div>
        <div class="stat-box">
          <span class="stat-label">AGI</span>
          <span class="stat-value">${playerData.stats.agi}</span>
        </div>
        <div class="stat-box">
          <span class="stat-label">INT</span>
          <span class="stat-value">${playerData.stats.int}</span>
        </div>
        <div class="stat-box">
          <span class="stat-label">VIT</span>
          <span class="stat-value">${playerData.stats.vit}</span>
        </div>
        <div class="stat-box">
          <span class="stat-label">LUK</span>
          <span class="stat-value">${playerData.stats.luk}</span>
        </div>
        <div class="stat-box">
          <span class="stat-label">DMG</span>
          <span class="stat-value">${playerData.stats.damage}</span>
        </div>
        <div class="stat-box">
          <span class="stat-label">DEF</span>
          <span class="stat-value">${playerData.stats.defense}</span>
        </div>
        <div class="stat-box">
          <span class="stat-label">SPD</span>
          <span class="stat-value">${playerData.stats.speed}</span>
        </div>
      </div>

      <div class="achievements-section">
        <h3>?? Achievements (${progress.unlocked}/${progress.total})</h3>
        <div class="achievement-list">
    `;

    if (achievements.length > 0) {
      achievements.forEach(achievement => {
        html += `
          <div class="achievement-badge">
            ${achievement.icon}
            <div class="achievement-tooltip">
              <strong>${achievement.title}</strong><br>
              ${achievement.description}
            </div>
          </div>
        `;
      });
    } else {
      html += '<p style="color: rgba(255, 255, 255, 0.5); text-align: center;">No achievements unlocked yet. Start shopping!</p>';
    }

    html += `
        </div>
      </div>
    `;

    container.innerHTML = html;
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderPlayerStats);
  } else {
    renderPlayerStats();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["player-console"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  // Constants
  const CONFIG = {
    MODULE_RETRY_DELAY: 100,
    MODULE_MAX_RETRIES: 50,
    UPDATE_INTERVAL: 5000,
    CONSOLE_WIDTH: 450,
    CONSOLE_MIN_WIDTH: 60
  };

  const consoleElement = document.querySelector('[data-cs-console]');
  if (!consoleElement) return;

  const toggle = consoleElement.querySelector('[data-cs-console-toggle]');
  const content = consoleElement.querySelector('[data-cs-console-content]');
  const resetBtn = consoleElement.querySelector('[data-cs-reset]');

  // Toggle console minimize/maximize
  if (toggle && content) {
    // Load saved state (default to expanded if no saved state)
    const isMinimized = localStorage.getItem('cs-console-minimized') === 'true';
    if (isMinimized) {
      consoleElement.classList.add('minimized');
      content.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    } else {
      // Start expanded by default
      consoleElement.classList.remove('minimized');
      content.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
    }

    // Toggle on click
    toggle.addEventListener('click', () => {
      const minimized = consoleElement.classList.contains('minimized');
      
      if (minimized) {
        // Maximize
        consoleElement.classList.remove('minimized');
        content.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        localStorage.setItem('cs-console-minimized', 'false');
      } else {
        // Minimize
        consoleElement.classList.add('minimized');
        content.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        localStorage.setItem('cs-console-minimized', 'true');
      }
    });

    // Keyboard accessibility - Enter or Space to toggle
    toggle.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle.click();
      }
    });

    // Also toggle on header click
    const header = consoleElement.querySelector('.cs-console__header');
    if (header) {
      header.addEventListener('click', (e) => {
        if (e.target !== toggle && !toggle.contains(e.target)) {
          toggle.click();
        }
      });
    }
  }

  // Track retry attempts
  let moduleRetryCount = 0;

  // Update console with player data
  function updateConsole() {
    if (!window.CyberSells_playerData || !window.CyberSells_stats) {
      moduleRetryCount++;
      if (moduleRetryCount < CONFIG.MODULE_MAX_RETRIES) {
        window.console.log('[CyberSells] Waiting for modules... (attempt ' + moduleRetryCount + '/' + CONFIG.MODULE_MAX_RETRIES + ')');
        setTimeout(updateConsole, CONFIG.MODULE_RETRY_DELAY);
      } else {
        window.console.error('[CyberSells] Failed to load modules after ' + CONFIG.MODULE_MAX_RETRIES + ' attempts');
      }
      return;
    }
    
    // Reset retry count on success
    moduleRetryCount = 0;

    const playerData = window.CyberSells_playerData.loadPlayerData();
    const progress = window.CyberSells_stats.getLevelProgress(playerData);
    const xpForNext = window.CyberSells_stats.getXpForLevel(playerData.level);

    // Update level
    const levelEl = consoleElement.querySelector('[data-cs-level]');
    if (levelEl) levelEl.textContent = playerData.level;

    // Update XP
    const xpFill = consoleElement.querySelector('[data-cs-xp-fill]');
    const xpCurrent = consoleElement.querySelector('[data-cs-xp-current]');
    const xpNext = consoleElement.querySelector('[data-cs-xp-next]');
    
    if (xpFill) xpFill.style.width = (progress * 100) + '%';
    if (xpCurrent) xpCurrent.textContent = playerData.xp;
    if (xpNext) xpNext.textContent = xpForNext;

    // Update stats
    for (const [stat, value] of Object.entries(playerData.stats)) {
      const statEl = consoleElement.querySelector(`[data-cs-stat-${stat}]`);
      if (statEl) statEl.textContent = value;
    }

    // Update achievements
    if (window.CyberSells_achievements) {
      const achievementList = consoleElement.querySelector('[data-cs-achievement-list]');
      const achievementCount = consoleElement.querySelector('[data-cs-achievement-count]');
      const unlocked = window.CyberSells_achievements.getUnlockedAchievements(playerData);
      const progress = window.CyberSells_achievements.getAchievementProgress(playerData);

      if (achievementCount) {
        achievementCount.textContent = `${progress.unlocked}/${progress.total}`;
      }

      if (achievementList && unlocked.length > 0) {
        achievementList.innerHTML = unlocked.map(a => `
          <span class="cs-console__achievement" title="${a.title}: ${a.description}">
            ${a.icon}
            <span class="cs-console__achievement-tooltip">
              <strong>${a.title}</strong><br>${a.description}
            </span>
          </span>
        `).join('');
      }
    }

    // Update equipment
    if (window.CyberSells_equipment) {
      updateEquipment();
    }
  }

  // Validate URL to prevent XSS
  function isValidImageUrl(url) {
    if (!url || typeof url !== 'string') return false;
    try {
      const urlObj = new URL(url, window.location.origin);
      return urlObj.protocol === 'http:' || urlObj.protocol === 'https:';
    } catch (e) {
      return false;
    }
  }

  // Update equipment display
  function updateEquipment() {
    if (!window.CyberSells_equipment) return;

    const equipment = window.CyberSells_equipment;
    const loadout = equipment.getLoadout();
    const slots = consoleElement.querySelectorAll('[data-cs-equipment-slots] .cs-equipment-slot');
    const equipmentCount = consoleElement.querySelector('[data-cs-equipment-count]');
    
    // Count equipped items
    let equippedCount = 0;
    
    // Update each slot
    slots.forEach(slotEl => {
      const slotName = slotEl.getAttribute('data-slot');
      const item = loadout[slotName];
      
      if (item) {
        equippedCount++;
        slotEl.classList.remove('cs-slot-empty');
        slotEl.classList.add('cs-slot-equipped');
        
        // Update ARIA label
        slotEl.setAttribute('aria-label', `${slotName} slot: ${item.title || 'equipped'}`);
        
        // Update slot content
        const iconEl = slotEl.querySelector('.cs-slot-icon');
        const labelEl = slotEl.querySelector('.cs-slot-label');
        
        // Update/create icon with image if available
        if (iconEl && item.image && isValidImageUrl(item.image)) {
          // Safely create and set image element with validated URL
          const img = document.createElement('img');
          img.src = item.image;
          img.alt = item.title || 'Equipped item';
          img.style.width = '32px';
          img.style.height = '32px';
          img.style.objectFit = 'contain';
          iconEl.innerHTML = '';
          iconEl.appendChild(img);
        } else if (iconEl && !item.image) {
          // No image available, use default icon
          iconEl.textContent = '??';
        }
        
        if (labelEl) {
          // Create item display if it doesn't exist
          let itemEl = slotEl.querySelector('.cs-slot-item');
          if (!itemEl) {
            itemEl = document.createElement('span');
            itemEl.className = 'cs-slot-item';
            slotEl.appendChild(itemEl);
          }
          itemEl.textContent = item.title || 'Equipped';
          labelEl.style.display = 'none';
        }
      } else {
        slotEl.classList.add('cs-slot-empty');
        slotEl.classList.remove('cs-slot-equipped');
        
        // Update ARIA label
        slotEl.setAttribute('aria-label', `${slotName} slot: empty`);
        
        // Reset slot content
        const iconEl = slotEl.querySelector('.cs-slot-icon');
        const labelEl = slotEl.querySelector('.cs-slot-label');
        const itemEl = slotEl.querySelector('.cs-slot-item');
        
        // Reset icon to placeholder
        if (iconEl) {
          iconEl.innerHTML = '?';
        }
        
        if (labelEl) labelEl.style.display = '';
        if (itemEl) itemEl.remove();
      }
    });

    // Update equipment count
    if (equipmentCount) {
      equipmentCount.textContent = `${equippedCount}/7`;
    }

    // Update stats from equipment totals
    if (equipment.computeTotals) {
      const totals = equipment.computeTotals();
      for (const [stat, value] of Object.entries(totals)) {
        // Handle stat name variations (e.g., "luck" -> "luk")
        const statNames = [stat];
        if (stat === 'luck') statNames.push('luk');
        if (stat === 'luk') statNames.push('luck');
        
        statNames.forEach(statName => {
          const statEl = consoleElement.querySelector(`[data-cs-stat-${statName}]`);
          if (statEl) {
            statEl.textContent = value || 0;
          }
        });
      }
    } else {
      window.console.warn('[Player Console] equipment.computeTotals not available');
    }

    // Update match score
    const matchScoreEl = consoleElement.querySelector('[data-cs-match-score]');
    if (matchScoreEl) {
      const { score, label } = equipment.computeMatchScore();
      
      const valueEl = matchScoreEl.querySelector('.cs-match-value');
      const statusEl = matchScoreEl.querySelector('.cs-match-status');
      const fillEl = matchScoreEl.querySelector('.cs-match-fill');
      
      if (valueEl) valueEl.textContent = Math.round(score);
      if (statusEl) statusEl.textContent = label;
      if (fillEl) fillEl.style.width = score + '%';
    }
  }

  // Reset progress (dev only)
  if (resetBtn) {
    resetBtn.addEventListener('click', () => {
      if (confirm('Reset all player progress? This cannot be undone.')) {
        window.CyberSells_playerData?.resetPlayerData();
        updateConsole();
      }
    });
  }

  // Clear equipment button
  const clearBtn = consoleElement.querySelector('[data-cs-equipment-clear]');
  if (clearBtn) {
    clearBtn.addEventListener('click', () => {
      if (window.CyberSells_equipment) {
        window.CyberSells_equipment.clearLoadout({ storageKey: 'cybersells_loadout', autoSave: true });
        updateEquipment();
      }
    });
  }

  // Add keyboard accessibility to equipment slots
  const equipmentSlots = consoleElement.querySelectorAll('.cs-equipment-slot');
  equipmentSlots.forEach(slot => {
    slot.setAttribute('tabindex', '0');
    slot.setAttribute('role', 'button');
    
    slot.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        slot.click();
      }
    });
  });

  // Listen for purchase events
  document.addEventListener('cybersells:purchase', updateConsole);
  
  // Listen for equipment changes
  document.addEventListener('cybersells:equipment-changed', () => {
    updateEquipment();
  });

  // Initial update
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateConsole);
  } else {
    updateConsole();
  }

  // Update periodically with Page Visibility API for performance
  let updateIntervalId = null;
  
  function startUpdateInterval() {
    if (!updateIntervalId) {
      updateIntervalId = setInterval(updateConsole, CONFIG.UPDATE_INTERVAL);
    }
  }
  
  function stopUpdateInterval() {
    if (updateIntervalId) {
      clearInterval(updateIntervalId);
      updateIntervalId = null;
    }
  }
  
  // Start interval
  startUpdateInterval();
  
  // Pause updates when page is hidden
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      stopUpdateInterval();
    } else {
      startUpdateInterval();
      updateConsole(); // Update immediately when becoming visible
    }
  });
  
  // Listen for storage changes from other tabs
  window.addEventListener('storage', (e) => {
    if (e.key === 'cybersells_player' || e.key === 'cybersells_loadout') {
      updateConsole();
    }
  });

  // Companion toggle handler
  const companionToggle = consoleElement.querySelector('[data-cs-companion-toggle]');
  if (companionToggle) {
    // Load saved state from localStorage
    const companionState = localStorage.getItem('pixelCompanion');
    if (companionState) {
      try {
        const state = JSON.parse(companionState);
        companionToggle.checked = !state.dismissed;
      } catch (e) {
        companionToggle.checked = true;
      }
    } else {
      // Default to checked when no saved state exists
      companionToggle.checked = true;
    }

    // Handle checkbox change
    companionToggle.addEventListener('change', (e) => {
      const shouldShow = e.target.checked;
      
      // Get or create companion instance
      if (window.pixelCompanion) {
        window.pixelCompanion.state.dismissed = !shouldShow;
        window.pixelCompanion.toggleVisibility();
      } else {
        // Update localStorage directly if companion hasn't initialized yet
        const currentState = localStorage.getItem('pixelCompanion');
        let state = currentState ? JSON.parse(currentState) : {};
        state.dismissed = !shouldShow;
        localStorage.setItem('pixelCompanion', JSON.stringify(state));
        
        // Reload page to apply
        if (!shouldShow) {
          const avatar = document.querySelector('.pixel-companion-avatar');
          const bubble = document.querySelector('.pixel-companion-bubble');
          if (avatar) avatar.style.display = 'none';
          if (bubble) bubble.style.display = 'none';
        } else {
          location.reload();
        }
      }
    });

    // Sync checkbox state with companion changes
    document.addEventListener('companion:toggled', (e) => {
      companionToggle.checked = !e.detail.dismissed;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["post-purchase-rewards"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  const container = document.querySelector('[data-cs-post-purchase]');
  if (!container) return;

  const rewardsContainer = container.querySelector('[data-rewards-container]');
  const shareContainer = container.querySelector('[data-share-container]');
  const nextStepsContainer = container.querySelector('[data-next-steps]');
  const milestonesContainer = container.querySelector('[data-milestones]');

  // Get order info from URL or Shopify data
  const urlParams = new URLSearchParams(window.location.search);
  const orderId = urlParams.get('order_id') || (window.Shopify?.checkout?.order_id);

  function init() {
    if (!window.CyberSells_postPurchase) {
      setTimeout(init, 100);
      return;
    }

    loadAndDisplayRewards();
  }

  function loadAndDisplayRewards() {
    const rewards = window.CyberSells_postPurchase.getStoredRewards();

    if (!rewards) {
      rewardsContainer.innerHTML = '<p class="cs-post-purchase__empty">No rewards found. Complete a purchase to earn rewards!</p>';
      return;
    }

    displayRewards(rewards);
    setupSocialSharing(rewards);
    displayNextSteps();
  }

  function displayRewards(rewards) {
    let html = '';

    // Level Up Card
    if (rewards.level.leveledUp) {
      html += `
        <div class="cs-reward-card cs-reward-card--level-up">
          <div class="cs-reward-card__header">
            <div class="cs-reward-card__icon">??</div>
            <h3 class="cs-reward-card__title">LEVEL UP!</h3>
          </div>
          <div class="cs-reward-card__body">
            <p>You've reached <strong>Level ${rewards.level.new}</strong>!</p>
            ${rewards.level.levelsGained > 1 ? `<p>You gained <strong>${rewards.level.levelsGained} levels</strong> from this purchase!</p>` : ''}
          </div>
        </div>
      `;
    }

    // XP Gained Card
    html += `
      <div class="cs-reward-card">
        <div class="cs-reward-card__header">
          <div class="cs-reward-card__icon">?</div>
          <h3 class="cs-reward-card__title">Experience Gained</h3>
        </div>
        <div class="cs-reward-card__body">
          <div class="cs-xp-counter" data-count-to="${rewards.xp.total}">0</div>
          <div class="cs-reward-card__stats">
            <div class="cs-reward-stat">
              <div class="cs-reward-stat__label">Base XP</div>
              <div class="cs-reward-stat__value">+${rewards.xp.base}</div>
            </div>
            ${rewards.xp.combo > 0 ? `
            <div class="cs-reward-stat">
              <div class="cs-reward-stat__label">Combo Bonus</div>
              <div class="cs-reward-stat__value">+${rewards.xp.combo}</div>
            </div>
            ` : ''}
            ${rewards.xp.achievement > 0 ? `
            <div class="cs-reward-stat">
              <div class="cs-reward-stat__label">Achievements</div>
              <div class="cs-reward-stat__value">+${rewards.xp.achievement}</div>
            </div>
            ` : ''}
          </div>
        </div>
      </div>
    `;

    // Stats Gained Card
    if (Object.keys(rewards.stats).length > 0) {
      html += `
        <div class="cs-reward-card">
          <div class="cs-reward-card__header">
            <div class="cs-reward-card__icon">??</div>
            <h3 class="cs-reward-card__title">Power Gained</h3>
          </div>
          <div class="cs-reward-card__body">
            <div class="cs-reward-card__stats">
      `;
      
      for (const [stat, value] of Object.entries(rewards.stats)) {
        html += `
          <div class="cs-reward-stat">
            <div class="cs-reward-stat__label">${stat.toUpperCase()}</div>
            <div class="cs-reward-stat__value">+${value}</div>
          </div>
        `;
      }
      
      html += `
            </div>
          </div>
        </div>
      `;
    }

    // Achievements Card
    if (rewards.achievements.length > 0) {
      html += `
        <div class="cs-reward-card">
          <div class="cs-reward-card__header">
            <div class="cs-reward-card__icon">??</div>
            <h3 class="cs-reward-card__title">Achievements Unlocked</h3>
          </div>
          <div class="cs-reward-card__body">
            <div class="cs-achievement-list">
      `;
      
      rewards.achievements.forEach(ach => {
        html += `
          <div class="cs-achievement-item">
            <div class="cs-achievement-item__icon">${ach.icon}</div>
            <div class="cs-achievement-item__info">
              <h4 class="cs-achievement-item__title">${ach.title}</h4>
              <p class="cs-achievement-item__desc">${ach.description}</p>
            </div>
          </div>
        `;
      });
      
      html += `
            </div>
          </div>
        </div>
      `;
    }

    // Quests Completed Card
    if (rewards.quests.length > 0) {
      html += `
        <div class="cs-reward-card">
          <div class="cs-reward-card__header">
            <div class="cs-reward-card__icon">???</div>
            <h3 class="cs-reward-card__title">Quests Completed</h3>
          </div>
          <div class="cs-reward-card__body">
            <div class="cs-achievement-list">
      `;
      
      rewards.quests.forEach(quest => {
        html += `
          <div class="cs-achievement-item">
            <div class="cs-achievement-item__icon">${quest.icon}</div>
            <div class="cs-achievement-item__info">
              <h4 class="cs-achievement-item__title">${quest.title}</h4>
              <p class="cs-achievement-item__desc">+${quest.reward.xp} XP (claim in Quest Board)</p>
            </div>
          </div>
        `;
      });
      
      html += `
            </div>
          </div>
        </div>
      `;
    }

    rewardsContainer.innerHTML = html;

    // Animate XP counter
    animateCounter(rewardsContainer.querySelector('[data-count-to]'));
  }

  function animateCounter(element) {
    if (!element) return;
    
    const target = parseInt(element.dataset.countTo);
    const duration = 2000;
    const steps = 60;
    const increment = target / steps;
    let current = 0;
    
    const timer = setInterval(() => {
      current += increment;
      if (current >= target) {
        element.textContent = `+${target} XP`;
        clearInterval(timer);
      } else {
        element.textContent = `+${Math.floor(current)} XP`;
      }
    }, duration / steps);
  }

  function setupSocialSharing(rewards) {
    const twitterBtn = container.querySelector('[data-share="twitter"]');
    const facebookBtn = container.querySelector('[data-share="facebook"]');

    if (twitterBtn) {
      twitterBtn.href = window.CyberSells_postPurchase.getTwitterShareUrl(rewards);
    }

    if (facebookBtn) {
      facebookBtn.href = window.CyberSells_postPurchase.getFacebookShareUrl();
    }

    shareContainer.style.display = 'block';
  }

  function displayNextSteps() {
    const milestones = window.CyberSells_postPurchase.getNextMilestone();
    
    if (!milestones || milestones.length === 0) {
      return;
    }

    let html = '';
    milestones.forEach(milestone => {
      const percentage = milestone.target ? (milestone.progress / milestone.target * 100).toFixed(0) : 0;
      
      html += `
        <div class="cs-milestone">
          <div class="cs-milestone__icon">${milestone.icon}</div>
          <div class="cs-milestone__info">
            <h4 class="cs-milestone__title">${milestone.title}</h4>
            <p class="cs-milestone__desc">${milestone.description}</p>
            ${milestone.target ? `
            <div class="cs-milestone__progress">
              <div class="cs-milestone__progress-fill" style="width: ${percentage}%"></div>
            </div>
            ` : ''}
          </div>
        </div>
      `;
    });

    milestonesContainer.innerHTML = html;
    nextStepsContainer.style.display = 'block';
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quest-board"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  const questBoard = document.querySelector('[data-cs-quest-board]');
  if (!questBoard) return;

  let currentTab = 'daily';

  // Tab switching
  const tabs = questBoard.querySelectorAll('[data-tab]');
  const panels = questBoard.querySelectorAll('[data-panel]');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const tabType = tab.dataset.tab;
      
      // Update active tab
      tabs.forEach(t => t.classList.remove('cs-quest-board__tab--active'));
      tab.classList.add('cs-quest-board__tab--active');

      // Update active panel
      panels.forEach(p => p.classList.remove('cs-quest-board__panel--active'));
      const panel = questBoard.querySelector(`[data-panel="${tabType}"]`);
      if (panel) panel.classList.add('cs-quest-board__panel--active');

      currentTab = tabType;
    });
  });

  // Load and render quests
  function updateQuestBoard() {
    if (!window.CyberSells_quests || !window.CyberSells_playerData) {
      setTimeout(updateQuestBoard, 100);
      return;
    }

    const playerData = window.CyberSells_playerData.loadPlayerData();
    const allQuests = window.CyberSells_quests.getActiveQuests(playerData);

    // Render each quest type
    ['daily', 'weekly', 'permanent'].forEach(type => {
      const questList = questBoard.querySelector(`[data-quest-list="${type}"]`);
      if (!questList) return;

      const quests = allQuests.filter(q => q.type === type);
      
      if (quests.length === 0) {
        questList.innerHTML = '<p class="cs-quest-board__loading">No quests available</p>';
        return;
      }

      questList.innerHTML = quests.map(quest => renderQuest(quest)).join('');

      // Add claim handlers
      questList.querySelectorAll('[data-quest-claim]').forEach(btn => {
        btn.addEventListener('click', () => claimQuest(btn.dataset.questClaim));
      });
    });
  }

  // Render a single quest
  function renderQuest(quest) {
    const progress = Math.min(quest.currentProgress, quest.maxProgress);
    const percentage = quest.percentage.toFixed(0);
    const completed = quest.completed;
    const claimed = quest.claimedReward;

    const statusClass = completed ? 'cs-quest--completed' : claimed ? 'cs-quest--claimed' : '';

    let rewards = '';
    if (quest.reward.xp) rewards += `<span class="cs-quest__reward">+${quest.reward.xp} XP</span>`;
    if (quest.reward.stats) {
      for (const [stat, value] of Object.entries(quest.reward.stats)) {
        rewards += `<span class="cs-quest__reward">+${value} ${stat.toUpperCase()}</span>`;
      }
    }

    return `
      <div class="cs-quest ${statusClass}">
        <div class="cs-quest__header">
          <div class="cs-quest__icon">${quest.icon}</div>
          <div class="cs-quest__info">
            <h3 class="cs-quest__title">${quest.title}</h3>
            <p class="cs-quest__description">${quest.description}</p>
          </div>
        </div>
        
        <div class="cs-quest__progress">
          <div class="cs-quest__progress-bar">
            <div class="cs-quest__progress-fill" style="width: ${percentage}%"></div>
          </div>
          <div class="cs-quest__progress-text">
            ${progress} / ${quest.maxProgress}
          </div>
        </div>

        <div class="cs-quest__footer">
          <div class="cs-quest__rewards">
            ${rewards}
          </div>
          ${completed && !claimed ? `
            <button 
              class="cs-quest__claim-btn" 
              data-quest-claim="${quest.id}"
            >
              Claim Reward
            </button>
          ` : claimed ? `
            <span class="cs-quest__status cs-quest__status--claimed">Claimed</span>
          ` : `
            <span class="cs-quest__status">${percentage}%</span>
          `}
        </div>
      </div>
    `;
  }

  // Claim quest reward
  function claimQuest(questId) {
    if (!window.CyberSells_quests || !window.CyberSells_playerData || !window.CyberSells_stats) {
      return;
    }

    const playerData = window.CyberSells_playerData.loadPlayerData();
    const reward = window.CyberSells_quests.claimQuestReward(questId, playerData);

    if (!reward) {
      console.warn('[CyberSells] Failed to claim quest reward');
      return;
    }

    // Apply rewards
    if (reward.rewards.xp) {
      const levelResult = window.CyberSells_stats.awardXp(playerData, reward.rewards.xp);
      if (levelResult.leveledUp && window.cyberSells?._toastSystem) {
        window.cyberSells._toastSystem.showLevelUp({
          newLevel: levelResult.newLevel,
          oldLevel: levelResult.oldLevel
        });
      }
    }

    if (reward.rewards.stats) {
      window.CyberSells_playerData.updatePlayerStats(playerData, reward.rewards.stats);
    }

    window.CyberSells_playerData.savePlayerData(playerData);

    // Show notification
    if (window.cyberSells?._toastSystem) {
      window.cyberSells._toastSystem.showToast('achievement', {
        icon: reward.quest.icon,
        title: 'Quest Complete!',
        description: reward.quest.title,
        xpReward: reward.rewards.xp
      });
    }

    // Refresh quest board
    updateQuestBoard();

    // Dispatch event
    document.dispatchEvent(new CustomEvent('cybersells:quest-claimed', {
      detail: { questId, reward }
    }));
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateQuestBoard);
  } else {
    updateQuestBoard();
  }

  // Listen for quest updates
  document.addEventListener('cybersells:quest-update', updateQuestBoard);
  document.addEventListener('cybersells:purchase', updateQuestBoard);

  // Periodic refresh
  setInterval(updateQuestBoard, 10000); // Every 10 seconds

})();

  } catch(e) { console.error(e); }
})();
})();
